import styled from 'styled-components';

export const DateSelectorWrapper = styled.div`
 display: grid;
 grid-template-columns: auto auto 1fr;
 grid-column: span 2;
 gap: 20px;
 font-size: 14px;
 align-self: start;
@media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    grid-column: 1;
  }
`;


export const LabelStyled = styled.label`
display: grid;
grid-template-columns: auto auto;
gap: 10px;
align-items: center;
font-size: 14px;
`;
